import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Tags, TagsState, TagTypes } from './types';

const INITIAL_STATE: TagsState = {
    data: {} as Tags,
    loading: true,
    hasError: false,
    error: undefined,
};

const reducer: Reducer<TagsState> = (state: TagsState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case TagTypes.GET_TAGS_REQUEST:
            return { ...state, loading: true };
        case TagTypes.GET_TAGS_SUCCESS:
            return { ...state, loading: false, data: { ...state.data, tags: action.payload } };
        case TagTypes.GET_SUGGESTION_TAGS_SUCCESS:
            return { ...state, loading: false, data: { ...state.data, suggestionTags: action.payload } };
        case TagTypes.GET_TAGS_FAILURE:
            return { ...state, loading: false, hasError: true, error: action.payload };
        case TagTypes.GET_TAGS_CLEAR:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;
